import * as React from "react";
import { Alert, AlertDescription, Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import styles from "./ExternalLinkConfirmation.module.css";

interface ExternalLinkConfirmationProps {
  onCancel: () => void;
  onContinue: () => void;
}

export const ExternalLinkConfirmation: React.FC<
  ExternalLinkConfirmationProps
> = ({ onCancel, onContinue }) => {
  return (
    <div className={styles.alertWrapper}>
      <Alert
        status="warning"
        onDismiss={(e) => {
          // prevents node being selected and sidebar opening
          e.stopPropagation();
          onCancel();
        }}
      >
        <AlertDescription>
          The link you clicked leads to an external site that isn&apos;t
          verified by Zapier. Only continue if you trust this site.
        </AlertDescription>
        <div className={styles.footerContent}>
          <Button variant="tertiary" size="small" onPress={onCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="small"
            iconPosition="start"
            onPress={onContinue}
          >
            <Icon name="arrowOffsite" size={15} />
            Continue
          </Button>
        </div>
      </Alert>
    </div>
  );
};
